import { ButtonDS, DialogModalDS, TextCapitalized } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import "../../../../i18n/i18n";

const modalName = "electric_charging.electric_vehicles.modal";

export const HomeChargingVehiclesModal = (props: {
  visible: boolean;
  onCloseModal: () => void;
}) => {
  const { t } = useTranslation();
  const { visible, onCloseModal } = props;

  return (
    <DialogModalDS
      visible={visible}
      width={44}
      onClose={onCloseModal}
      title={t(`${modalName}.title`) || ""}
      bottomButtons={{
        leftButton: (
          <ButtonDS
            text={t(`${modalName}.cancel`)}
            format={"fill"}
            buttonType={"secondary"}
            onClick={onCloseModal}
          />
        ),
        rightButton: (
          <ButtonDS
            text={t(`${modalName}.validate`)}
            format={"fill"}
            buttonType={"primary"}
            onClick={() => {}}
            disabled
          />
        ),
      }}
    >
      <StyledDescription>
        <TextCapitalized>{t(`${modalName}.description`)}</TextCapitalized>
      </StyledDescription>
    </DialogModalDS>
  );
};

const StyledDescription = styled.div`
  ${typographies["Body/M"]};
  color: ${colors["colors/text/darkGrey"]};
`;
